import __request__ from "routing/request";
export function create(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.views/views", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function views(sort = "title", page = 1, per_page = 50, order = "asc", query, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.views/views", null, { "page": page, "per_page": per_page, "sort": sort, "order": order, "query": query }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkDelete(Entitiestoremove, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.views/views/bulk_delete", Entitiestoremove, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(JSONbody, id, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.views/views/${id}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.views/views/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.views/views/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function duplicate(JSONbody, id, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.views/views/${id}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setDefault(id, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.views/views/${id}/default`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
